import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface StartConfirmEmailForCandidateResponse
  extends BackendResponse {}

export interface StartConfirmEmailForCandidateParameters extends NextApiParams {
  email: string;
}

export const startConfirmEmailForCandidate = withNextApi<
  StartConfirmEmailForCandidateResponse,
  StartConfirmEmailForCandidateParameters
>("/cvp/CvpStartEmailVerification");
